export const typeList = [
  { id: "father", name: "Father" },
  { id: "grandfather", name: "Grandfather" },
  { id: "grandmother", name: "Grandmother" },
  { id: "mother", name: "Mother" },
  { id: "guardian", name: "Guardian" },
  { id: "relative", name: "Relative" },
];

export const statusList = [
  { id: "active", name: "Active" },
  { id: "inactive", name: "Inactive" },
];

export const salutationList = [
  { id: "mr", name: "Mr" },
  { id: "mrs", name: "Mrs" },
  { id: "miss", name: "Miss" },
  { id: "mdm", name: "Mdm" },
];

export const typeTransactionList = [
  { id: "invoice", name: "Invoice", color: "#00bcd4" },
  { id: "credit_note", name: "Credit Note", color: "#7c4dff" },
  { id: "commercial_document_item", name: "Item", color: "#9e9e9e" },
];

export const typeInvoiceAndCreditNoteList = [
  { id: "invoice", name: "Invoice", color: "#00bcd4" },
  { id: "credit_note", name: "Credit Note", color: "#7c4dff" },
];

export const typeCommercialDocumentList = [
  { id: "invoice", name: "Invoice", color: "#00bcd4" },
  { id: "credit_note", name: "Credit Note", color: "#7c4dff" },
  { id: "payment", name: "Payment", color: "#9e9e9e" },
];

export const typeCommercialDocumentFilterList = [
  { id: "Invoice", name: "Invoice", color: "#00bcd4" },
  { id: "CreditNote", name: "Credit Note", color: "#7c4dff" },
  { id: "Payment", name: "Payment", color: "#9e9e9e" },
];

export const paymentStatusFilterList = [
  { id: "New", name: "New" },
  { id: "Cancelled", name: "Cancelled" },
  { id: "Paid", name: "Paid" },
  { id: "Failed", name: "Failed" },
  { id: "Expired", name: "Expired" },
  { id: "Posted", name: "Posted" },
];
